import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import tplHelpers from "../../../helpers/tpl";
import ThirdPartyLogisticsDiscrepanciesTable from './ThirdPartyLogisticsDiscrepanciesTable';
import ThirdPartyLogisticsDiscrepanciesPopup from './ThirdPartyLogisticsDiscrepanciesPopup';

function ThirdPartyLogisticsDiscrepancies(props) {

    const [discrepancies, setDiscrepancies] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState([]);
    const [selectedRowDetails, setSelectedRowDetails] = useState(null);
    const [editDiscrepancyPopup, setEditDiscrepancyPopup] = useState(false);

    useEffect(() => {
        getDiscrepancies();
    }, []);

    useEffect(() => {
        if (selectedIndex.length) {
            setSelectedRowDetails(discrepancies[selectedIndex[0]]);
        };
    }, [selectedIndex]);

    const getDiscrepancies = async () => {
        props.setLoading(true);
        try {
            const discrepancies = await tplHelpers.getDiscrepancies(props.company, props.token);
            setDiscrepancies(discrepancies);
        } catch (err) {
            console.log(err);
            props.toast.error('Failed to get discrepancies')
        } finally {
            props.setLoading(false);
        };
    };

    const exportDiscrepancies = async() => {
        const today = new Date();
        const formattedDate = `${today.getMonth() + 1}.${today.getDate()}.${today.getFullYear().toString().slice(-2)}`;
        let data = [
            ["acu_order_num", "timestamp", "from_warehouse", "to_warehouse", "sku", "shipped_qty", "received_qty", "status", "notes"].join(",")
        ];
        for(let row of discrepancies) {
            data.push([row.acu_order_num, row.timestamp, row.from_warehouse,  row.to_warehouse,  row.sku,  row.shipped,  row.received,  row.status,  row.notes].join(","));
        };
        let csv = data.join("\n");
        let uri = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        let a = document.createElement("a");
        a.setAttribute("href", uri);
        a.setAttribute("download", `${formattedDate} Transfer Order Discrepancies.csv`);
        document.body.appendChild(a);
        a.click();
    };

    const handleSelect = async(sel) => {
        let index = sel.length - 1;
        if (index < 0) setSelectedIndex([]);
        else setSelectedIndex([sel[sel.length - 1]]);
        return;
    };

    const updateDiscrepancyState = (discrepancy, status, notes) => {
        const newOrders = [];
        discrepancies.forEach(line => {
            if (line.acu_order_num === discrepancy.acu_order_num && line.sku === discrepancy.sku) {
                newOrders.push({
                    ...discrepancy,
                    status: status,
                    notes: notes,
                });
            } else {
                newOrders.push(line);
            };
        });
        setDiscrepancies(newOrders);
    };

    const updateSelectedDiscrepancy = (acu_order_num, sku) => {
        const new_discrepancy = discrepancies.find((discrepancy) => {
            return discrepancy.acu_order_num === acu_order_num && discrepancy.sku === sku;
        });

        if (!new_discrepancy) {
           props.toast.error('unexpectedly failed to find discrepancy');
        } else {
            setSelectedRowDetails(new_discrepancy);
        };
    };

    return (
        <Box display = "flex" flexDirection = "column" className = {props.isMobile ? "mobile-top" : "desktop-top"}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
                <h1>3PL Discrepancies</h1> 
                { editDiscrepancyPopup ? 
                    <ThirdPartyLogisticsDiscrepanciesPopup
                        discrepancies = {discrepancies}
                        open = {editDiscrepancyPopup} 
                        selectedRowDetails = {selectedRowDetails}
                        handleClose = {() => setEditDiscrepancyPopup(false)} 
                        toast = {props.toast}
                        isLoading = {props.isLoading}
                        setLoading = {props.setLoading}
                        company = {props.company}
                        token = {props.token}
                        updateDiscrepancyState = {updateDiscrepancyState}
                        updateSelectedDiscrepancy = {updateSelectedDiscrepancy}
                    /> 
                : null}
                { selectedIndex.length === 1 ?
                    <Box>
                        <Button 
                            sx = {{ 
                                backgroundColor: "#87b9c4",
                                '&:hover': {
                                    backgroundColor: "#536d73"
                                },
                                }} 
                            variant = "contained" 
                            onClick = {()=> setEditDiscrepancyPopup(true)}>
                            Update Status
                        </Button> 
                    </Box>
                 : null }
                { discrepancies ?
                    <ThirdPartyLogisticsDiscrepanciesTable 
                        isMobile = {props.isMobile}
                        discrepancies = {discrepancies}
                        exportDiscrepancies = {exportDiscrepancies}
                        selectedIndex = {selectedIndex}
                        handleSelect = {handleSelect}
                    />
                : null }
            </Box>
        </Box>
    );
}

export default ThirdPartyLogisticsDiscrepancies;